import {useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import {stepperData} from '../../contants';
import SelectStep from '../../elements/selectedStep';
import DotsLoading from '../../../../../components/dotsLoading';
import Stepper from '../../../../../components/mazraeKit/stepper';
import SuccessRegisterStoreModal from '../../modal/successRegisterStoreModal';
import MainFooter from '../../../../../components/mazraeKit/footers/footerMain';
import CustomHeader from '../../../../../components/mazraeKit/headers/homeHeader';
import useGetStoreSupplierProfile from '../../../../../services/hookService/getStoreSupplierProfile/useGetStoreSupplierProfile';
import {usePutStoreRedesignView} from '../../../../../services/hookService/putStoreRedesignView/usePutStoreRedesignView';
import {
  addRegisterStoreFormData,
  resetRegisterStore,
} from '../../../../../store/redux/registerStore';
import {RootState} from '../../../../../store/redux';
import {useDispatch, useSelector} from 'react-redux';

const EditRegisterStore = () => {
  const dispatch = useDispatch();
  const {state: stateParams} = useLocation();
  const state = useSelector((state: RootState) => state.registerStore);
  const navigate = useNavigate();
  // const state = useSelector((state: RootState) => state.registerStore);

  const [touched, setTouched] = useState(false);
  const [, setLabBottomSheet] = useState<boolean>(false);
  const [isSuccessModal, setIsSuccessModal] = useState<boolean>(false);
  // const [selectedLabInputs, setSelectedLabInputs] = useState<string[]>([]);
  const [currentStep, setCurrentStep] = useState<number>(1);

  const handleAfterSuccessSupplierProfile = (data: IStoreSupplierProfile) => {
    if (!state?.national_card?.file && !state?.national_card?.national_card) {
      dispatch(
        addRegisterStoreFormData({
          ...state,
          name: data?.name,
          supplier_profile_guid: data?.profile_guid,
          national_card: {file: null, national_card: data.national_card},
          phone_number: data.phone,
        }),
      );
    }
  };

  const {mutate, isLoading: isLoadingMutattion} = usePutStoreRedesignView({
    onSuccess: () => {
      dispatch(resetRegisterStore({}));
      setIsSuccessModal(true);
    },
  });

  const {data, isLoading} = useGetStoreSupplierProfile({
    handleAfterSuccessSupplierProfile,
  });

  useEffect(() => {
    setCurrentStep(stateParams?.tab || 1);
  }, [stateParams?.tab]);

  return (
    <div className="flex h-full flex-col">
      <CustomHeader
        title="ثبت فروشگاه"
        preIcon="icon-nameArrow---Right"
        isActiveRightIcon={true}
        postComponent={() => (
          <i
            className={`icon-namechat text-[25px] text-gray-700`}
            onClick={() => {
              navigate('/my-chats');
            }}
          />
        )}
      />
      {isLoading ? (
        <div className="flex h-full justify-center items-center">
          <DotsLoading />
        </div>
      ) : (
        <div className="flex flex-col h-full overflow-y-auto">
          <div className="w-full h-full flex flex-col overflow-y-auto py-3 px-3">
            <Stepper currentStep={currentStep} steps={stepperData} />
            <SelectStep
              setCurrentStep={setCurrentStep}
              setTouched={setTouched}
              touched={touched}
              currentStep={currentStep}
              profileData={data}
              setIsSuccessModal={setIsSuccessModal}
              setLabBottomSheet={setLabBottomSheet}
              storeGuid={stateParams?.guid}
              mutateFn={mutate}
              isLoadingMutattion={isLoadingMutattion}
              mode="edit"
              type="store"
            />
          </div>

          <SuccessRegisterStoreModal {...{isSuccessModal, setIsSuccessModal}} />
        </div>
      )}
      <MainFooter />
    </div>
  );
};

export default EditRegisterStore;
